// ISO calendar week helpers. ISO weeks start on Monday and the calendar-week
// caps in the tier matrix (voice 1/week, video 1/week at Seedling) use this
// boundary — not Sunday, not a rolling 7-day window. Extracted so it can be
// unit-tested without pulling the full entitlements hook into the test.

/**
 * Start of the ISO calendar week (Monday 00:00 local time) containing `d`.
 * Returns a new Date — does not mutate the input.
 */
export function startOfIsoWeek(d: Date): Date {
  const date = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const day = date.getDay(); // 0 = Sun, 1 = Mon, … 6 = Sat
  const offset = day === 0 ? 6 : day - 1;
  date.setDate(date.getDate() - offset);
  return date;
}
